import { demoRegistries } from "./demo-registries";

export const registriesQuery = {
  read(_: any) {
    return demoRegistries;
  },
};
